import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function Portfolio() {
  var BreadCrumbTitle = "Portfolio :: D-Right Technologies";
  document.title = BreadCrumbTitle;
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const portfolioItems = [
    {
      title: "Web Builder",
      description: "Build and manage your website with ease",
      link: "/web-builder",
      image: "/assets/img/web-builder.jpg"
    },
    {
      title: "LARIS",
      description: "Laboratory Information System for efficient lab management",
      link: "/laris",
      image: "/assets/img/laris.jpg"
    },
    {
      title: "MAPS",
      description: "Pharmacy Management System for streamlined operations",
      link: "/maps",
      image: "/assets/img/maps.jpg"
    },
    {
      title: "Quest",
      description: "Pipeline product for advanced healthcare solutions",
      link: "/quest",
      image: "/assets/img/quest.jpg"
    }
  ];

  return (
    <>
      <Header />
      <div className="main">
        <section
          className="page-header-section ptb-100 bg-image"
          image-overlay="8"
        >
          <div
            className="background-image-wraper"
            style={{
              background: `url('/assets/img/contactus-banner.jpg')`,
              opacity: "1",
            }}
          ></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-9 col-lg-7">
                <div className="page-header-content text-white pt-4">
                  <h1 className="text-white mb-0">Portfolio</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="breadcrumb-bar gray-light-bg border-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="custom-breadcrumb">
                  <ol className="breadcrumb pl-0 mb-0 bg-transparent">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Portfolio</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="portfolio-section ptb-100">
          <div className="container">
            <div className="row">
              {portfolioItems.map((item, index) => (
                <div key={index} className="col-md-6 col-lg-3 mb-4">
                  <div className="card single-portfolio-card shadow-sm h-100">
                    <div className="card-body text-center p-4">
                      <div className="portfolio-icon mb-3">
                        <span className="fas fa-laptop-code icon-size-lg color-primary"></span>
                      </div>
                      <h5 className="mb-3">{item.title}</h5>
                      <p className="text-muted mb-4">{item.description}</p>
                      <Link
                        to={item.link}
                        className="btn btn-brand-02 btn-sm"
                      >
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Portfolio;
